<template>
  <div id="photo-show">
    <disabled-overlay />
    <profile-module />
    <b-col>
      <h1 class="title">{{ $t('pages.photo.title') }}</h1>
    </b-col>
    <e-index
      :uri="$helper.getUri('photo')"
      :modal-uri-create="`api/public/memorial/${id}/photo`"
      :modal-uri="`api/memorial/${id}/photo`"
      :order-call-back="orderCallBack"
      :can-manage="$root.canManage()"
      :can-create="!$root.isDemo() || $root.canManage()"
      name="photo"
      mode="mosaic"
    >
      <div slot="mosaic-content" slot-scope="ctx">
        <div
          :style="`background-image:url(${imgurl(ctx.item.image.file_url, 'full')})`"
          class="thumbnail clickable"
          @click="openModal(modalName('image'), ctx.item)"
        >
          <i class="ti ti-fw ti-2x ti-search" />
        </div>
        <contact-entity :contact="ctx.item.contact" />
      </div>
    </e-index>
    <e-modal :event-id="modalName('image')" :title="$helper.demoFallbackTranslation(photo, 'title')" class="has-navigate">
      <navigate :item="photo" name="photo" />
      <template v-if="photo.image">
        <img :src="imgurl(photo.image.file_url, 'full')" class="img-fluid">
      </template>
      <p>{{ $helper.demoFallbackTranslation(photo, 'description') }}</p>
    </e-modal>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import EModal from '@/components/EModal';
  import ProfileModule from '@/components/ProfileModule';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import Navigate from '@/components/Navigate';
  import ContactEntity from '@/components/ContactEntity';
  import MemorialGuard from '@/mixins/MemorialGuard';

  export default {
    name: 'PhotoIndex',
    components: {
      EIndex,
      EModal,
      ProfileModule,
      DisabledOverlay,
      Navigate,
      ContactEntity,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        photo: {},
        photos: {},
      };
    },
    mounted() {
      this.$bus.$once(`t-event.t-modal.image-${this.uid}.closed`, () => {
        this.photo = {};
      });
      this.$bus.$on('t-event.ajax-index.load-data-success', (photos) => {
        this.photos = this.orderCallBack(photos);
      });
      this.$bus.$on('t-event.navigate.success', (photo) => {
        this.photo = photo;
        this.addNextPrev(this.photo);
      });
    },
    methods: {
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        if (id === this.modalName('image')) {
          this.photo = this.addNextPrev(data);
        }
        this.$bus.$emit(`t-event.t-modal.${id}.open`, this.photo);
      },
      addNextPrev(data) {
        const currentPhotoKey = _.findIndex(this.photos, photo => photo.id === data.id);

        if (this.photos[currentPhotoKey + 1]) {
          data.next = this._.omit(this.photos[currentPhotoKey + 1], 'next', 'prev');
        }

        if (this.photos[currentPhotoKey - 1]) {
          data.prev = this._.omit(this.photos[currentPhotoKey - 1], 'next', 'prev');
        }

        return data;
      },
      orderCallBack(collection) {
        return _.orderBy(collection, ['created_at'], ['desc']);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  /deep/ .sweet-modal {
    img {
      display: block;
      max-height: 70vh;
      margin: auto auto 20px auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Photo/index.vue